module.exports = __webpack_public_path__ + "img/streamline-icon-warehouse-1@450x450.5ef11da2.svg";